export default "/_next/static/images/8be977416a886642b62519c88952cc4a.svg";